import { Select } from "@mui/material";
import { styled } from "@mui/system";

export const CustomSelect = styled(Select)({
  // width: "100%",
});
